// deeply remove keys with a value of undefined
// also ensures that empty arrays have been "properly" created (and can be serialised by the firestore api)
// this helper can fix up any objects that are to be reduced so that missing values are removed

// do not clone some types, it messes them up
const canProcess = object => object !== null && (
	Object.getPrototypeOf(object).constructor.name === 'Object' ||
	Object.getPrototypeOf(object).constructor.name === 'Array'
)

const removeUndefined = (object) => {
	const newObject = Array.isArray(object) ? [...object] : { ...object }
	if (newObject) {
		Object.keys(newObject).forEach((key) => {
			if (newObject[key] === undefined) {
				delete newObject[key]
			} else if (Array.isArray(newObject[key]) && !newObject[key].length) {
				newObject[key] = []
			} else if (canProcess(newObject[key])) {
				newObject[key] = removeUndefined(newObject[key])
			}
		})
	}
	return newObject
}

export default removeUndefined



// WEBPACK FOOTER //
// ./src/utilities/Data/removeUndefined.js